const lpHashimotoMain = (() => {

  const pageLpHashimoto1_2 = (document.getElementById("pageLpHashimoto1_2") != null);

  if (pageLpHashimoto1_2) {
    console.log("object");

    const jsSecMain = document.getElementById('jsSecMain');
    const mainSwiper = jsSecMain.querySelector('.js-main-swiper');

    const swiper = new Swiper(mainSwiper, {
      slidesPerView: 1,
      effect: 'fade',
      speed: 2000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      }
    });

  }


})();
export default lpHashimotoMain;